import { UserTypes } from "@/types";
import { ApiResponse } from "@/types/api";
import $api from "@/utils/request";

const PREF = "/admin";

const UserRoutes = {
  login: `${PREF}/login`,
  reg: `${PREF}/register`,
  getUser: `${PREF}`,
};

export const login = async (data: UserTypes.LoginData) => {
  return await $api.post<ApiResponse<{ token: string; status: "ok" }>>(
    UserRoutes.login,
    data
  );
};

export const registration = async (data: UserTypes.RegData) => {
  return await $api.post<ApiResponse<{ token: string }>>(UserRoutes.reg, data, {
    headers: {
      Authorization: localStorage.getItem("reg_t") || "",
    },
  });
};

export const getCurrentUser = async () => {
  return await $api.get(UserRoutes.getUser);
};
